<app-header></app-header>
    <div class="container-fluid">
        @if (isLogged()) {
        <div class="d-flex">
            <app-sidebar></app-sidebar>
            
            <main class="col-12 col-md-10 col-lg-10 px-md-4 pt-3 ms-md-auto">
                <app-toast/>
                <router-outlet />
            </main>
        </div>
        } @else {
        <div class="row justify-content-center align-items-center vh-100">
            <main class="col-md-6 col-lg-4">
                <app-toast/>
                <router-outlet />
            </main>
        </div>
        }
    </div>